export default {
    BEIGE: 'Beige',
    BLACK: 'Black',
    BLUE: 'Blue',
    BROWN: 'Brown',
    BURGUNDY: 'Burgundy',
    CHARCOAL: 'Charcoal',
    GOLD: 'Gold',
    GRAY: 'Gray',
    GREEN: 'Green',
    OFFWHITE: 'Off White',
    ORANGE: 'Orange',
    PINK: 'Pink',
    PURPLE: 'Purple',
    RED: 'Red',
    SILVER: 'Silver',
    TAN: 'Tan',
    TURQUOISE: 'Turquoise',
    WHITE: 'White',
    YELLOW: 'Yellow',
};
